var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgHelpCenter = function SvgHelpCenter(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.28414 7.04869C10.5561 5.73698 13.396 7.37658 13.396 10C13.396 11.2175 12.7464 12.3425 11.692 12.9513C9.42011 14.263 6.5802 12.6234 6.5802 10C6.5802 8.78249 7.22974 7.65747 8.28414 7.04869ZM12.3054 10C12.3054 8.21607 10.3743 7.10114 8.82941 7.99311C8.11239 8.4071 7.67072 9.1721 7.67072 10C7.67072 11.7839 9.60186 12.8989 11.1468 12.0069C11.8638 11.5929 12.3054 10.8279 12.3054 10Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0064 12.4473C10.2193 12.2343 10.5645 12.2343 10.7775 12.4473L14.2813 15.9511C14.4943 16.1641 14.4943 16.5093 14.2813 16.7222C14.0684 16.9352 13.7232 16.9352 13.5102 16.7222L10.0064 13.2184C9.79342 13.0055 9.79342 12.6602 10.0064 12.4473Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4353 10.0191C12.6482 9.80611 12.9935 9.80607 13.2064 10.019L16.7103 13.5221C16.9233 13.735 16.9233 14.0802 16.7104 14.2932C16.4975 14.5062 16.1522 14.5062 15.9393 14.2933L12.4354 10.7902C12.2224 10.5773 12.2224 10.232 12.4353 10.0191Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5408 10.0183C7.75374 10.2312 7.75374 10.5765 7.5408 10.7894L4.03695 14.2932C3.82401 14.5062 3.47877 14.5062 3.26584 14.2932C3.0529 14.0803 3.0529 13.7351 3.26584 13.5221L6.76969 10.0183C6.98263 9.80534 7.32787 9.80534 7.5408 10.0183Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.96985 12.4481C10.1828 12.661 10.1827 13.0063 9.96977 13.2192L6.46592 16.7223C6.25295 16.9352 5.90771 16.9352 5.6948 16.7222C5.48188 16.5092 5.48192 16.164 5.69488 15.9511L9.19873 12.448C9.41169 12.2351 9.75693 12.2351 9.96985 12.4481Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.6948 3.27854C5.90771 3.06558 6.25295 3.06554 6.46592 3.27846L9.96977 6.78156C10.1827 6.99448 10.1828 7.33972 9.96985 7.55268C9.75694 7.76564 9.41169 7.76567 9.19873 7.55276L5.69488 4.04966C5.48192 3.83674 5.48188 3.4915 5.6948 3.27854Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.26584 5.70675C3.47877 5.49382 3.82401 5.49382 4.03695 5.70675L7.5408 9.21061C7.75374 9.42354 7.75374 9.76878 7.5408 9.98172C7.32787 10.1947 6.98263 10.1947 6.76969 9.98172L3.26584 6.47787C3.0529 6.26493 3.0529 5.91969 3.26584 5.70675Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7103 5.70675C16.9233 5.91969 16.9233 6.26493 16.7103 6.47787L13.2065 9.98172C12.9935 10.1947 12.6483 10.1947 12.4354 9.98172C12.2224 9.76879 12.2224 9.42354 12.4354 9.21061L15.9392 5.70675C16.1522 5.49382 16.4974 5.49382 16.7103 5.70675Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2814 3.27854C14.4943 3.4915 14.4942 3.83674 14.2813 4.04966L10.7774 7.55276C10.5645 7.76567 10.2192 7.76564 10.0063 7.55268C9.79341 7.33972 9.79344 6.99448 10.0064 6.78156L13.5103 3.27846C13.7232 3.06554 14.0685 3.06558 14.2814 3.27854Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99404 3.08211C11.3194 0.00750458 17.9762 3.85078 17.9762 10C17.9762 12.8538 16.4537 15.4909 13.9821 16.9179C8.65674 19.9925 2 16.1492 2 10C2 7.14616 3.52249 4.50907 5.99404 3.08211ZM16.8856 10C16.8856 4.69027 11.1377 1.37167 6.5393 4.02653C4.40517 5.25868 3.09052 7.53576 3.09052 10C3.09052 15.3097 8.83849 18.6283 13.4369 15.9735C15.571 14.7413 16.8856 12.4642 16.8856 10Z",
    fill: "currentColor"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHelpCenter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "help-center.4d79b84c21c58d977e761f94459237fe.svg";